import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useToast } from "@/hooks/use-toast";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

/**
 * Starts the €49.90 Poros Žemėlapis checkout (single digital product, no shipping).
 * Shared by the /poros-zemelapis page, the /zemelapis cards and the home page strip.
 */
export function usePorosCheckout(redirectTo = "/poros-zemelapis") {
  const { user } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [buying, setBuying] = useState(false);

  const startPorosCheckout = useCallback(async (gift = false) => {
    if (!user) { navigate(`/auth?redirect=${encodeURIComponent(redirectTo)}`); return; }
    setBuying(true);
    try {
      const { data: sessData } = await supabase.auth.getSession();
      const accessToken = sessData.session?.access_token;
      if (!accessToken) { navigate(`/auth?redirect=${encodeURIComponent(redirectTo)}`); return; }
      const { data, error } = await supabase.functions.invoke("create-poros-checkout", {
        body: { gift },
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (error) throw new Error(error.message);
      const res = data as { url?: string; duplicate?: boolean; message?: string };
      if (res?.duplicate) {
        toast({
          title: "Pirkti dar kartą nereikia",
          description: res.message || "Šis pirkinys jau yra tavo paskyroje.",
        });
        return;
      }
      const url = res?.url;
      if (!url) throw new Error("Nepavyko pradėti apmokėjimo");
      window.top ? (window.top.location.href = url) : (window.location.href = url);
    } catch (e) {
      toast({
        title: "Nepavyko",
        description: e instanceof Error ? e.message : "Pabandyk dar kartą",
        variant: "destructive",
      });
    } finally {
      setBuying(false);
    }
  }, [user, navigate, toast, redirectTo]);

  return { startPorosCheckout, buying };
}
